module.exports = __webpack_public_path__ + "img/non-smoker.d4b6c8d4.svg";